import useMarketStrategy from "../../strategies/market/useMarketStrategy";
import { Profile } from "./Profile";
import type { PsychologistProfile as IPsychologistProfile } from "core/types";
import { usePsychologistUser } from "hooks";
import { useCurrentUser } from "hooks/userHooks";

export function PsychologistProfile() {
  const marketStrategy = useMarketStrategy();
  const { user } = useCurrentUser();
  const { psychologist, isLoading } = usePsychologistUser({
    includeDetails: true,
  });

  if (psychologist && user) {
    const psychologistProfile: IPsychologistProfile = {
      psychologistId: psychologist.psychologistId,
      thumbnail: psychologist.thumbnail,
      firstName: psychologist.user.firstName,
      lastName: psychologist.user.lastName,
      ...psychologist.details,
      languages: psychologist.details.languages.map(
        (language) => language.languageId,
      ),
      specialities: psychologist.details.specialities.map(
        (speciality) => speciality.specialityId,
      ),
      descriptions: psychologist.details.descriptions.map((description) => ({
        ...description,
        description: description.description ?? "",
        countryLanguage: {
          languageId: description.languageId,
          countryId: description.countryId,
        },
      })),
      comments: psychologist.details.comments.map((comment) => ({
        ...comment,
        comment: comment.comment ?? "",
        countryLanguage: {
          languageId: comment.languageId,
          countryId: comment.countryId,
        },
      })),
      headlineEnum:
        psychologist.details.headlineEnum ??
        marketStrategy.psychologist.headlineKeys[0],
    };
    return <Profile user={user} psychologist={psychologistProfile} />;
  }

  if (!psychologist && !isLoading && user) {
    return <Profile user={user} psychologist={null} />;
  }

  return null;
}
